var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vl-calendar',{ref:"calendar",attrs:{"is-selected":_vm.isSelected,"is-disabled":_vm.isDisabled,"is-ranged":_vm.isRanged},on:{"input":function (date) { return _vm.emitDate(date); },"hover":function (date) { return _vm.hover(date); }}})}
var staticRenderFns = []

export { render, staticRenderFns }